import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { DFormGroup } from "../../entities/form-group";

@Component({
	selector: "form-group",
	template: `
		<div class="dynamic-field form-group" [formGroup]="group">
			<ng-content select="h3" />

			@for (field of config.children; track field) {
				<ng-container dynamicField [config]="field" [group]="group" />
			}
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormGroupComponent {
	@Input() config: DFormGroup;
	@Input() group: UntypedFormGroup;
}
